export default __webpack_public_path__ + "static/media/Nice-Room.b5e8fd3b.jpg";